var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasMounted)?_c('div',_vm._l((_vm.sites),function(site){return _c('map-polygon',{key:site._id,attrs:{"data-layer":_vm.dataLayer,"id":site._id,"geom":site.geometry,"properties":site.properties},on:{"polygon-event":_vm.onPolygonEvent}})}),1):_c('div')
}
var staticRenderFns = []

export { render, staticRenderFns }